import React from 'react';
import CompanyScanAppShell from './CompanyScanAppShell';
import CompanyScanFriendlyError from './CompanyScanFriendlyError';

interface Props {
  error?: unknown;
}

const CompanyScanError = ({ error }: Props) => {
  return (
    <CompanyScanAppShell>
      <CompanyScanFriendlyError error={error} />
    </CompanyScanAppShell>
  );
};

export default CompanyScanError;
